module.exports = __webpack_public_path__ + "img/couples-056.530baf3c.jpg";